<template>
  <table class="tbl select-tbl">
    <!--<colgroup>-->
      <!--<col width="110px">-->
      <!--<col width="21%">-->
      <!--<col width="19%">-->
      <!--<col width="22%">-->
      <!--<col width="22%">-->
      <!--<col width="1000px">-->
    <!--</colgroup>-->
    <thead>
      <tr>
        <th>구분</th>
        <th>이름</th>
        <th>회사명</th>
        <th>연락처</th>
        <th>이메일</th>
        <th v-if="items[0].idcCode == 'N2CDT010320'">생년월일</th>
        <th>반입자산</th>
      </tr>
    </thead>
    <tbody>

      <tr v-for="(item, index) in items" :key="index">
        <td>{{item.isApplicant ? '신청자' : '동행자'}}</td>
        <td>{{item.visitorName}}</td>
        <td>{{item.visitorCompany}}</td>
        <td>{{item.visitorPhone}}</td>
        <td>{{item.visitorMail}}</td>
        <td v-if="items[0].idcCode == 'N2CDT010320'">{{item.visitorBirth}}</td>
        <td>
          <button class="btn btn-sm line-1 mr-6" :title="getAssetList(item)" data-toggle="tooltip" data-placement="bottom">{{item.assetList.length}}대</button>
        </td>
      </tr>

    </tbody>
  </table>
</template>

<script>
export default {
  props: ['items'],
  computed: {
    getDate(){
      return (date) =>{
        console.log(this.items);
        return moment(date).format(this.dateFormat);
      }
    },
  },
  methods : {
    getAssetList: function(item){
      let result = "";
      for(let i = 0 ; i < item.assetList.length ; i++){
        let asset = item.assetList[i]
        result += asset.assetStr+" : "+asset.assetManufacturer+" "+asset.assetModel + "("+asset.assetSerial+")";
        if(i<item.assetList.length-1) result += "\r";
      }
      return result;
    }
  }
}
</script>

<style>

</style>
